// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"38da3cf1","653":"11b11cd8","667":"b8bcad4a","977":"2ce54969"}[chunkId] + ".chunk.js";
};